export const environment = {
    production: false,
    ticketServerUrl: 'https://ticket.relyit.net/ticket-server',
    klarnaCheckoutUrl: "https://ticketfarja.relyit.net/buy-ticket",
    klarnaConfirmationUrl: "https://ticketfarja.relyit.net/klarna-confirmation",
    sveaCheckoutUrl: "https://ticketfarja.relyit.net/svea-checkout/",
    sveaConfirmationUrl: "https://ticketfarja.relyit.net/svea-confirmation/",
    webUrl: 'https://ticketfarja.relyit.net',
    baseUrl: 'https://ticketfarja.relyit.net',
    appVersion: require('../../package.json').version,
    showTerms: true,
    situationsTopic: 'situations-labb'
  };